import { render, staticRenderFns } from "./modalTherapiesNotes.vue?vue&type=template&id=5cb90742&"
import script from "./modalTherapiesNotes.vue?vue&type=script&lang=js&"
export * from "./modalTherapiesNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports